<template>
  <div class="suggest-to-pc">
    <span class="ball ball-1"></span>
    <span class="ball ball-2"></span>
    <span class="ball ball-3"></span>
    <span class="ball ball-4"></span>
    <span class="ball ball-5"></span>
    <ul>
      <li>
        <span class="ball"></span>
      </li>
      <li>
        <span class="ball"></span>
      </li>
      <li>
        <span class="ball"></span>
      </li>
      <li>
        <span class="ball"></span>
      </li>
    </ul>

    <div class="content">
      <img src="@/assets/aiot-pc.svg" class="img-pc" />
      <h3>请前往电脑端进行注册与登录</h3>
      <el-button type="primary" round @click="handleCopy">复制链接</el-button>
    </div>

    <div class="footer flex column">
      <span>©{{ new Date().getFullYear() }} <a href="https://www.frippler.com/" class="footer-link">Frippler | 鱼漾智能科技（上海）有限公司</a></span>
      <span class="ml"><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" class="footer-link">沪ICP备 16026565 号</a></span>
    </div>

  </div>
</template>

<script>
import clipboard from  '@/utils/clipboard'
export default {
  name: "Login",

  data() {
    return {
    }
  },

  methods: {
    handleCopy(event) {
      clipboard('https://aiot.frippler.com/', event)
    }
  },
};
</script>

<style lang="scss" scoped>
.suggest-to-pc {
  overflow: hidden;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
  background-color: #f9fffc;
  background-size: 100% auto;
  .ball {
    position: absolute;
    display: block;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background-size: 100% auto;

    &.ball-1 {
      top: 300px;
      left: 160px;
      width: 140px;
      height: 140px;
      transform: rotate(-90deg);
      background: linear-gradient(0deg, #8bd09a 19%, #f2f9f7 90%);
      opacity: 0.3;
    }
    &.ball-2 {
      top: 80px;
      left: 80px;
      width: 40px;
      height: 40px;
      transform: rotate(130deg);
      background: radial-gradient(circle at 22%, #f9fffc 0%, #37d17d);
    }
    &.ball-3 {
      top: -190px;
      left: 50%;
      transform: translateX(-50%) rotate(-90deg);
      width: 320px;
      height: 320px;
      background: linear-gradient(0deg, #8bd09a 19%, #f2f9f7 90%);
      opacity: 0.3;
    }
    &.ball-4 {
      top: 180px;
      right: 15%;
      width: 100px;
      height: 100px;
      transform: rotate(90deg);
      background: radial-gradient(circle at 22%, #f9fffc 0%, #37d17d);
    }
    &.ball-5 {
      top: 50%;
      right: 60px;
      width: 120px;
      height: 120px;
      transform: rotate(-90deg);
      background: linear-gradient(0deg, #8bd09a 19%, #f2f9f7 90%);
      opacity: 0.3;
    }
  }
  .content {
    background-color: rgba(255, 255, 255, 0.9);
    box-shadow: -2px 8px 50px 0px rgba(238, 240, 240, 1);
    min-width: 340px;
    width: 80%;
    z-index: 999;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    text-align: center;
    padding: 40px 20px;
    border-radius: 10px;

    .img-pc {
      width: 200px;
      height: 200px;
    }

    h3 {
      font-size: 20px;
      color: #101010;
    }

    .el-button {
      width: 100%;
      margin-top: 90px;
    }
  }
  .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 20px;
    text-align: center;
    .footer-link {
      &:hover, &:focus {
        text-decoration: underline;
      }
    }
  }

  ul {
    width: 1300px;
    height: 1300px;
    margin: 40px auto;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    list-style: none;

    li {
      border: 2px solid #ceedd79f;
      position: absolute;
      left: 50%;
      top: 60%;
      border-radius: 50%;
      transform: translate(-50%, -50%);
      box-sizing: border-box;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
      animation-name: orbit;
    }
    li .ball {
      display: block;
      position: absolute;
      left: 0;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: linear-gradient(0deg, #8bd09a 19%, #f2f9f7 90%);
      background-size: 100% auto;
    }
    li:nth-child(1) {
      width: 30%;
      height: 30%;
      animation-duration: 14s;
    }
    li:nth-child(1) .ball {
      left: 20%;
      top: 6%;
      width: 20px;
      height: 20px;
      // opacity: 0.3;
    }
    &li:nth-child(2) {
      width: 50%;
      height: 50%;
      animation-duration: 16s;
    }
    li:nth-child(2) .ball {
      left: 75%;
      top: 6%;
      width: 40px;
      height: 40px;
      // opacity: 0.3;
    }
    li:nth-child(3) {
      width: 60%;
      height: 60%;
      animation-duration: 28s;
    }
    li:nth-child(3) .ball {
      width: 60px;
      height: 60px;
      left: 11%;
      top: 11%;
      background: radial-gradient(circle at 22%, #f9fffc 0%, #37d17d);
    }
    li:nth-child(4) {
      width: 100%;
      height: 100%;
      animation-duration: 32s;
      margin-top: 8%;
    }
    li:nth-child(4) > .ball {
      width: 80px;
      height: 80px;
      left: 12%;
      top: 12%;
      transform: rotate(120deg);
      // animation: orbit 180s infinite linear;
      background: radial-gradient(circle at 22%, #f9fffc 0%, #37d17d);
    }
  }

  @keyframes orbit {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }
}

</style>
<style>
.mobile-message {
  width: 300px;
  min-width: 0;
}
</style>
